import { z } from "zod";
import type { DocumentTypeConfig } from "../types";

// Only checked at upload for coherence warnings, never persisted.
export const SocialSecurityCardDataSchema = z.object({
  first_name: z.string().optional(),
  last_name: z.string().optional(),
  social_security_number: z.string().optional(),
});

export type SocialSecurityCardData = z.infer<typeof SocialSecurityCardDataSchema>;

export const SocialSecurityCardExtractionSchema = z.object({
  isValidDocumentType: z.boolean(),
  reason: z.string().optional(),
  first_name: z.string().nullable(),
  last_name: z.string().nullable(),
  social_security_number: z.string().nullable(),
});

export type SocialSecurityCardExtraction = z.infer<typeof SocialSecurityCardExtractionSchema>;

export const SocialSecurityCardContextSchema = z.object({
  talentId: z.guid(),
});

export type SocialSecurityCardContext = z.infer<typeof SocialSecurityCardContextSchema>;

type SocialSecurityCardConfig = DocumentTypeConfig<
  typeof SocialSecurityCardDataSchema,
  typeof SocialSecurityCardContextSchema
>;

export const SOCIAL_SECURITY_CARD_CONFIG: SocialSecurityCardConfig = {
  documentType: "social_security_card",
  documentName: "Carte vitale",
  maxFiles: 2,
  acceptedMimeTypes: ["image/jpeg", "image/png", "image/webp", "application/pdf"],
  dataSchema: SocialSecurityCardDataSchema,
  contextSchema: SocialSecurityCardContextSchema,
  requiredFields: [],
  fieldLabels: {
    first_name: "Prénom",
    last_name: "Nom",
    social_security_number: "Numéro de sécurité sociale",
  },
};
